import { GlIcon, GlBadge, GlPopover, GlSkeletonLoader } from '@gitlab/ui';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { STATUS_CLOSED, STATUS_MERGED } from '~/issues/constants';
import { __ } from '~/locale';
import CiIcon from '~/vue_shared/components/ci_icon/ci_icon.vue';
import timeagoMixin from '~/vue_shared/mixins/timeago';
import query from '../queries/merge_request.query.graphql';
export default {
    name: 'MrPopover',
    components: {
        GlIcon,
        GlBadge,
        GlPopover,
        GlSkeletonLoader,
        CiIcon
    },
    directives: {
        SafeHtml
    },
    mixins: [
        timeagoMixin
    ],
    props: {
        target: {
            type: HTMLAnchorElement,
            required: true
        },
        namespacePath: {
            type: String,
            required: true
        },
        iid: {
            type: String,
            required: true
        },
        cachedTitle: {
            type: String,
            required: true
        },
        cachedTitleHtml: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            mergeRequest: {},
            notFound: false
        };
    },
    computed: {
        detailedStatus () {
            return this.mergeRequest.headPipeline && this.mergeRequest.headPipeline.detailedStatus;
        },
        formattedTime () {
            return this.timeFormatted(this.mergeRequest.createdAt);
        },
        badgeVariant () {
            switch(this.mergeRequest.state){
                case STATUS_MERGED:
                    return 'info';
                case STATUS_CLOSED:
                    return 'danger';
                default:
                    return 'success';
            }
        },
        stateHumanName () {
            switch(this.mergeRequest.state){
                case STATUS_MERGED:
                    return __('Merged');
                case STATUS_CLOSED:
                    return __('Closed');
                default:
                    return __('Open');
            }
        },
        titleHtml () {
            return this.mergeRequest?.titleHtml || this.cachedTitleHtml;
        },
        showDetails () {
            return Object.keys(this.mergeRequest).length > 0;
        }
    },
    apollo: {
        mergeRequest: {
            query,
            update: (data)=>data.project?.mergeRequest || {},
            variables () {
                const { namespacePath, iid } = this;
                return {
                    projectPath: namespacePath,
                    iid
                };
            },
            result ({ data, loading }) {
                // No record means it does not exist or the viewer cannot read it: show nothing.
                if (!loading && data) this.notFound = !data.project?.mergeRequest;
            }
        }
    }
};
